'use client';

import { FC } from 'react';
import { shallow } from 'zustand/shallow';

import { filterSidebarStore } from '@/stores/filterSidebarStore';

import { FilterHierarchyFieldsGroupOption, FilterOption, PlpFiltersConditionalProps } from '../../PlpFilters.type';
import { FilterHierarchyFieldsGroup } from '../Fields/FilterHierarchyFieldsGroup';
import { getFilteredOptions } from './PlpFiltersMake.helper';

type Props = {
  options: FilterHierarchyFieldsGroupOption[];
  currentFilters: FilterOption[];
  subCategoryLabel: string;
} & PlpFiltersConditionalProps;

export const PlpFiltersMake: FC<Props> = ({ options, currentFilters, subCategoryLabel, ...props }) => {
  const { displayMode, setDisplayMode } = filterSidebarStore(
    (state) => ({
      displayMode: state.displayMode,
      setDisplayMode: state.setDisplayMode,
    }),
    shallow,
  );

  const filteredOptions = getFilteredOptions(options, displayMode);

  return (
    <div>
      <p className="c-fs-body1 mb-4 font-extrabold">
        {displayMode === 'popular' ? 'Popular makes' : 'All makes A-Z'}
      </p>
      <FilterHierarchyFieldsGroup
        options={filteredOptions}
        subCategoryLabel={subCategoryLabel}
        currentFilters={currentFilters}
        sortAlphabetically={displayMode === 'all'}
        {...props}
      />
      {/* Option display toggle */}
      <button
        className="c-fs-body2 mt-4 cursor-pointer border-none bg-transparent p-0 font-extrabold text-tex-def-tie1 underline hover:no-underline"
        type="button"
        data-testid="PlpFiltersMake-displaySwitch"
        onClick={() => {
          setDisplayMode(displayMode === 'popular' ? 'all' : 'popular');
        }}
      >
        {displayMode === 'popular' ? 'See all makes' : 'See popular makes'}
      </button>
    </div>
  );
};
